/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ExternalReviewTypeEnum =
  (typeof ExternalReviewTypeEnum)[keyof typeof ExternalReviewTypeEnum];

export const ExternalReviewTypeEnum = {
  externalreview: 'externalreview',
  ertestimonial: 'ertestimonial',
} as const;
